export default {
    param:{
        name:"Instance Name",
        param_content_name_placeholder:'Please enter the parameter name.',
        code:"ID/SN",
        desc:"Description",
        type:"Asset type",
        param_content_name:"Parameter Content Name",
        param_content_code:"Parameter Content ID",
        param_contetn_value:"Parameter  Content Value",
        placeholder:"Please enter",
        
        // 返回状态码对应的提示信息
        code_1:"Deletion successful",
        code_3:"System Error",
        code_0:"Deletion failed",
        code_400:"Failed",
        code_200:"Send Successful",
        code_407:"Name already exists.",
        code_408:"ID/SN already exists.",
        code_409:"ID/SN already exists.",
        code_other:"System Error",

        title_add_param_content:"New Parameter Content",
        title_add_param_type:"New Parameter Type"
    }
}